__turbopack_context__.v({
  "icon": "aQwjIW_icon",
  "message": "aQwjIW_message",
  "toast": "aQwjIW_toast",
  "toast--bottom-center": "aQwjIW_toast--bottom-center",
  "toast--bottom-left": "aQwjIW_toast--bottom-left",
  "toast--bottom-right": "aQwjIW_toast--bottom-right",
  "toast--error": "aQwjIW_toast--error",
  "toast--hidden": "aQwjIW_toast--hidden",
  "toast--info": "aQwjIW_toast--info",
  "toast--inline": "aQwjIW_toast--inline",
  "toast--lg": "aQwjIW_toast--lg",
  "toast--md": "aQwjIW_toast--md",
  "toast--sm": "aQwjIW_toast--sm",
  "toast--success": "aQwjIW_toast--success",
  "toast--top-center": "aQwjIW_toast--top-center",
  "toast--top-left": "aQwjIW_toast--top-left",
  "toast--top-right": "aQwjIW_toast--top-right",
  "toast--warning": "aQwjIW_toast--warning",
});
